/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {Loader} from './style';

interface ILoaderContainer {
  size?: 'small' | 'medium' | 'large';
  color?: 'light' | 'dark';
}

const LoaderContainer = ({size = 'large', color = 'light'}: ILoaderContainer): JSX.Element => (
  <Loader className={size} color={color}>
    <span className="testId-loader" />
  </Loader>
);

export default LoaderContainer;